// removed by extract-text-webpack-plugin
module.exports = {"container":"_2XFF7","v-align-middle":"_1rToJ","button-container":"_3x5RJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CoverPhotoEditor/ImageEditor/ImageEditor.scss
// module id = ./src/components/CoverPhotoEditor/ImageEditor/ImageEditor.scss
// module chunks = 5